import { render, staticRenderFns } from "./BriqToggleSwitch.vue?vue&type=template&id=e28acaf0&scoped=true&lang=pug&"
import script from "./BriqToggleSwitch.vue?vue&type=script&lang=js&"
export * from "./BriqToggleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BriqToggleSwitch.vue?vue&type=style&index=0&id=e28acaf0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28acaf0",
  null
  
)

export default component.exports